import { useLanguage } from '@/hooks/Contexts'
import { ButtonHTMLAttributes, FC, Fragment, useCallback, useState } from 'react'

export const useLoadMore = () => {
  const [pageIndex, setPageIndex] = useState<number>(0)
  const [total, setTotal] = useState<number>(0)
  const [list, setList] = useState<Array<Record<string, any>>>([])
  const resetParams = useCallback(() => {
    setPageIndex(0)
    setTotal(0)
    setList([])
  }, [])
  const loadMore = () => {
    if (list?.length < total) {
      setPageIndex(prev => prev + 1)
    }
  }
  return { pageIndex, setPageIndex, total, setTotal, list, setList, resetParams, loadMore }
}

const LoadMoreButton: FC<ButtonHTMLAttributes<HTMLButtonElement> & { current?: number; total?: number }> = ({ current = 0, total = 0, className, ...rest }) => {
  const {
    actions: { load_more },
  } = useLanguage()
  return (
    <button {...rest} className={`btn-rd-amber btn-hover-amber btn-width ${className || ''}`} disabled={current >= total}>
      {load_more}
      {total > 0 ? (
        <Fragment>
          &nbsp;{current}/{total}
        </Fragment>
      ) : null}
    </button>
  )
}
export default LoadMoreButton
